import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons';

// Utils
import { parseFontAwesomeClass } from '../../../utils/fontawesome/config';
import cn from '../../../utils/cn';

// Styles
import styles from './LabelWithIconAndColor.module.css';

/**
 * LabelWithIconAndColor - Displays a label with optional icon
 * @param {object} params
 * @param {string | import('react').ReactNode} params.label - Text (or node) to display
 * @param {string | null} [params.icon] - FontAwesome icon class (e.g., "fal fa-check") (if provided, displays icon)
 * @param {string | null} [params.iconColor] - Color of the icon
 * @param {string} [params.labelColor='var(--neutral-900)'] - Color of the label
 * @param {"right" | "left"} [params.iconPosition='left'] - Position of the icon
 * @param {string} [params.className] - Additional CSS classes
 * @param {boolean} [params.hasColorSquareFallback=false] - Displays a colored square when there is no icon but an iconColor
 * @returns {JSX.Element} LabelWithIconAndColor component
 */
function LabelWithIconAndColor({
  label,
  icon,
  iconColor,
  className,
  labelColor = 'var(--neutral-900)',
  iconPosition = 'left',
  hasColorSquareFallback = false,
}) {
  const hasColorSquare = !icon && hasColorSquareFallback && !!iconColor && iconColor !== 'transparent';
  const iconDefinition = icon ? parseFontAwesomeClass(icon) : null;

  return (
    <div className={cn([styles.container, className])}>
      {hasColorSquare && (
        <FontAwesomeIcon
          icon={faSquare}
          className={styles['color-square']}
          style={{ color: iconColor }}
          aria-label={`Couleur: ${iconColor}`}
        />
      )}
      {iconDefinition && iconPosition === 'left' && (
        <FontAwesomeIcon
          icon={/** @type {any} */ (iconDefinition)}
          className={styles.icon}
          style={{ color: iconColor || 'currentColor' }}
        />
      )}
      <span className={styles.label} style={{ color: labelColor }}>{label}</span>
      {iconDefinition && iconPosition === 'right' && (
        <FontAwesomeIcon
          icon={/** @type {any} */ (iconDefinition)}
          className={styles.icon}
          style={{ color: iconColor || 'currentColor' }}
        />
      )}
    </div>
  );
}

export default LabelWithIconAndColor;
